<div class="card">
  <div class="flex mb-4 gap-2 w-full">
    <toolbar [actions]="toolbarActions" title="Gestion des Caisses"/>
  </div>
  <div class="alm-card p-0 mb-4 border-round-2xl shadow-1 transition-all transition-duration-300 hover:shadow-3 bg-white">
    <div class="bg-white border-round-bottom-xl m-4 border-3 border-gray-100">
      <p-card class="mb-4">
        <ng-template pTemplate="header">
          <div class="px-3 pt-3">
            <h3 class="m-0">Recherche de caisses</h3>
          </div>
        </ng-template>

        <form [formGroup]="searchForm" class="flex align-items-end gap-3">

          <div class="flex-1">
            <label for="institution" class="block mb-2">Institutions</label>
            <p-select
              id="institution"
              formControlName="institution"
              [options]="institutions"
              optionLabel="name"
              optionValue="id"
              placeholder="Sélectionner une institution"
              [filter]="true"
              [showClear]="true"
              styleClass="w-full">
            </p-select>
          </div>

          <div class="flex-1">
            <label for="type" class="block mb-2">Types</label>
            <p-select
              id="type"
              formControlName="type"
              [options]="cashRegistersType"
              optionLabel="type"
              optionValue="type"
              placeholder="Sélectionner un type"
              [filter]="true"
              [showClear]="true"
              styleClass="w-full">
            </p-select>
          </div>

          <div class="flex-1">
            <label for="status" class="block mb-2">Statuts</label>
            <p-select
              id="status"
              formControlName="status"
              [options]="cashRegistersStatus"
              optionLabel="status"
              optionValue="status"
              placeholder="Sélectionner un statut"
              [filter]="true"
              [showClear]="true"
              styleClass="w-full">
            </p-select>
          </div>

          <!-- Boutons d'action -->
          <div class="flex gap-2">
            <p-button
              icon="pi pi-refresh"
              severity="secondary"
              [rounded]="true"
              pTooltip="Réinitialiser"
              tooltipPosition="top"
              (onClick)="onReset()">
            </p-button>
            <p-button
              icon="pi pi-search"
              severity="primary"
              [rounded]="true"
              pTooltip="Rechercher"
              tooltipPosition="top"
            (onClick)="onSearch()">
            </p-button>
          </div>
        </form>
      </p-card>
    </div>
    <div class="bg-white border-round-bottom-xl m-4 border-3 border-gray-100">
      <dynamic-table
        [data]="cashRegistersToDisplay"
        [headers]="columns"
        [pageParams]="pageable"
        [actions]="actions"
        (paginate)="onPageChange($event)">
        <div *ngIf="!hasSearched" class="text-center p-5">
          <i class="pi pi-search" style="font-size: 3rem; color: var(--surface-400);"></i>
          <p class="text-xl mt-3" style="color: var(--surface-600);">Veuillez effectuer une recherche pour afficher les comptes</p>
        </div>
        <p-progressSpinner [hidden]="!displaySpinner" strokeWidth="2" fill="transparent" animationDuration=".5s" [style]="{ width: '50px', height: '50px', stoke: '#004F78' }" />
    
        <div *ngIf="hasSearched && cashRegistersToDisplay.length === 0 && !displaySpinner" class="text-center p-5">
          <i class="pi pi-inbox" style="font-size: 3rem; color: var(--surface-400);"></i>
          <p class="text-xl mt-3" style="color: var(--surface-600);">Aucune compte trouvé</p>
        </div>
      </dynamic-table>
    </div>
  </div>
</div>
